import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { AnswersWrapper, FAQWrapper, Heading, QuestionsWrapper } from "../../atoms/Menu";
import { Modal } from "react-bootstrap";
import { AddChildCloseIcon, Templateiconstylehead, Templatetextstylehead } from "../../atoms/ConnectStories";
import faq from "../../../images/faq_logo.svg";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { constants } from "../../../constants";
import * as LogoutAction from "@mywvglobal-shared/mywv-shared/action/persistItemsAction";
import { logoutUser } from "../../../utilities/LogOutUtils";
import DOMPurify from "dompurify";
import useApiRepository from "../../../api/useApiRepository";

function FAQs(props) {
  const { loginReducer } = useSelector((state) => state);
  const dispatch = useDispatch();
  const { persistItemsReducer } = useSelector((state) => state);
  const { connectFeedReducer } = useSelector((state) => state);
  const [visibleAns, setVisibleAns] = useState(0);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const apiRepo = useApiRepository();

  const getConnectFAQ = () => {
    const valuesToReplace = loginReducer?.getSOConfiguration?.faqFormatter?.configKeys;
    let replaceValuesFormatted = "";

    if (valuesToReplace) {
      const splittedValues = valuesToReplace.split("|");
      if (splittedValues) {
        for (let counter = 0; counter < splittedValues?.length; counter++) {
          const value = splittedValues[counter];
          const val = loginReducer?.getSOConfiguration[value];
          replaceValuesFormatted += val;
          if (counter !== splittedValues.length - 1) {
            replaceValuesFormatted += "|";
          }
        }
      }
    }
    apiRepo.connectRepository.getConnectFAQ(replaceValuesFormatted);
  };

  const clickHandler = (e) => {
    const el = e.target.closest("a");
    if (el && e.currentTarget.contains(el) && e?.target?.href?.includes("/connect") && params?.childcode) {
      e.preventDefault();
      navigate(`/connect/${params?.childcode}/WriteAmessage`)
    }
    else if (el && e.currentTarget.contains(el) && e?.target?.href?.includes("/myaccount")) {
      e.preventDefault();
      navigate("/myaccount", { state: { childcode: params?.childcode } });
    }
    else if (el && e.currentTarget.contains(el) && e?.target?.href?.includes("/help_feedback")) {
      e.preventDefault();
      navigate("/getHelp", { state: { childcode: params?.childcode, navigateFrom: "connectfaq" } });
    }
  }

  useEffect(() => {
    getConnectFAQ();
  }, [props?.isVisible]);

  async function handleUnauthorizedTokenError() {
    await logoutUser({
      persistItemsReducer, loginReducer, dispatch,
      LogoutAction, constants,
    });
  }

  useEffect(() => {
    // if token is expired or unauthorized, logout user
    if (connectFeedReducer?.errorMessage?.status === 401) {
      handleUnauthorizedTokenError()
      return
    }
  }, [connectFeedReducer?.errorMessage?.status]);

  //Accordion smooth scroll
  function openItemHandler(e) {
    let _this = e;
    let scrollParent = document.getElementById("help_accordion");
    setTimeout(() => {
      if (_this.target) {
        scrollParent.scrollTo({
          //   top: _this.target.offsetTop,
          top: _this.target.parentElement.offsetTop,
          left: 0,
          behavior: "smooth",
        });
      }
    }, 400);
  }

  return (

    <Modal
      className="faqs-popup"
      show={props?.isVisible}
    >
      <AddChildCloseIcon onClick={props?.setVisibility}>X</AddChildCloseIcon>
      <Heading faq>
        <Templateiconstylehead>
          <img src={faq} style={{ scale: "1.4" }} alt="" />
        </Templateiconstylehead>
        <Templatetextstylehead>{t("FAQs")}</Templatetextstylehead>
      </Heading>

      <FAQWrapper onClick={openItemHandler} id="help_accordion">

        {connectFeedReducer?.getConnectFAQ?.faqDetailsList?.map((item, index) => {
          return (
            <QuestionsWrapper key={index} >
              <span>
                {item?.question}
                {visibleAns === index + 1 &&
                  <AnswersWrapper onClick={(e) => {
                    clickHandler(e);
                    props?.setVisibility();
                  }}>
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.answer) }} />
                  </AnswersWrapper>
                }
              </span>
              <button onClick={() => { setVisibleAns(visibleAns === index + 1 ? 0 : index + 1) }}
                open={visibleAns === index + 1 ? true : false} />
            </QuestionsWrapper>
          )
        })}
      </FAQWrapper>
    </Modal>)
}

export default FAQs;